var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Brands',
        to: '/brands'
      }, {
        label: 'Add New'
      }],
      "title": "New Brands"
    }
  }), _c('div', {
    staticClass: "flex-col w-full bg-white shadow-sm rounded-lg px-4 py-4"
  }, [_c('div', {
    staticClass: "w-1/2"
  }, [_c('form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-gray-700 mb-2",
    attrs: {
      "for": "name"
    }
  }, [_vm._v(" Brand Name ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.name,
      expression: "form.name"
    }],
    class: ['w-full rounded-md px-4 py-2.5 text-sm focus:outline-none focus:ring-2', _vm.submitted && !_vm.form.name ? 'bg-red-300 focus:ring-red-500 placeholder-red-500' : 'border-gray-300 '],
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": "Enter Brand Name"
    },
    domProps: {
      "value": _vm.form.name
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value);
      }
    }
  }), _vm.submitted && !_vm.form.name ? _c('p', {
    staticClass: "text-red-500 text-sm mt-1"
  }, [_vm._v("Must be filled.")]) : _vm._e()]), _c('div', {
    staticClass: "mb-3 flex justify-between"
  }, [_c('div', {
    staticClass: "flex-col w-full"
  }, [_c('div', {
    staticClass: "grid grid-cols-2 gap-4 pr-2"
  }, [_c('div', [_c('label', {
    staticClass: "block text-sm font-medium text-gray-700 mb-2",
    attrs: {
      "for": "name"
    }
  }, [_vm._v(" Brand Code ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.brand_code,
      expression: "form.brand_code"
    }],
    class: ['w-full rounded-md px-4 py-2.5 text-sm focus:outline-none focus:ring-2', _vm.submitted && !_vm.form.brand_code ? 'bg-red-300 focus:ring-red-500  placeholder-red-500 ' : 'border border-gray-300 '],
    attrs: {
      "id": "brand_code",
      "type": "text",
      "placeholder": "Enter Brand Code"
    },
    domProps: {
      "value": _vm.form.brand_code
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "brand_code", $event.target.value);
      }
    }
  }), _vm._v(" "), _vm.submitted && !_vm.form.brand_code ? _c('p', {
    staticClass: "text-red-500 text-sm mt-1"
  }, [_vm._v("Must be filled.")]) : _vm._e()]), _c('div', [_c('div', [_c('label', {
    staticClass: "block text-sm font-medium text-gray-700 mb-2",
    attrs: {
      "for": "name"
    }
  }, [_vm._v(" Publisher ")]), _c('multiselect', {
    staticClass: "custom-multiselect",
    class: {
      'error': _vm.submitted && !_vm.form.vendor_id
    },
    attrs: {
      "id": "vendor",
      "label": "name",
      "track-by": "name",
      "placeholder": "Select Publisher",
      "open-direction": "bottom",
      "options": _vm.vendorSearchOptions,
      "searchable": true,
      "loading": _vm.isVendorSearch,
      "close-on-select": true
    },
    on: {
      "search-change": _vm.getVendorFind
    },
    scopedSlots: _vm._u([{
      key: "noResult",
      fn: function () {
        return [_c('span', {
          staticClass: "text-sm text-gray-500 px-2 py-1"
        }, [_vm._v("No publisher found.")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.form.vendor_id,
      callback: function ($$v) {
        _vm.$set(_vm.form, "vendor_id", $$v);
      },
      expression: "form.vendor_id"
    }
  }), _vm.submitted && !_vm.form.vendor_id ? _c('p', {
    staticClass: "text-red-500 text-sm mt-1"
  }, [_vm._v("Must be filled.")]) : _vm._e()], 1)])])])]), _c('div', {
    staticClass: "mb-3 flex justify-between"
  }, [_c('div', {
    staticClass: "flex-col w-full"
  }, [_c('div', {
    staticClass: "grid grid-cols-3 gap-4 pr-0"
  }, [_c('div', [_c('label', {
    staticClass: "block text-sm font-medium text-gray-700 mb-2",
    attrs: {
      "for": "name"
    }
  }, [_vm._v(" Default Contents Type ")]), _c('TypeContent', {
    attrs: {
      "options": _vm.defaultItemTypeOption,
      "isError": _vm.contentTypeValidate,
      "defaultText": 'Select Default Contents Type'
    },
    model: {
      value: _vm.form.default_item_type,
      callback: function ($$v) {
        _vm.$set(_vm.form, "default_item_type", $$v);
      },
      expression: "form.default_item_type"
    }
  }), _vm.contentTypeValidate ? _c('p', {
    staticClass: "text-red-500 text-sm mt-1"
  }, [_vm._v("Must be filled.")]) : _vm._e()], 1), _c('div', [_c('label', {
    staticClass: "block text-sm font-medium text-gray-700 mb-2",
    attrs: {
      "for": "name"
    }
  }, [_vm._v(" Default Contents Schedule ")]), _c('TypeContent', {
    attrs: {
      "options": _vm.defaultBrandTypeOption,
      "defaultText": 'Select Default Contents Schedule',
      "isError": _vm.contentScheduleValidate
    },
    model: {
      value: _vm.form.default_item_schedule,
      callback: function ($$v) {
        _vm.$set(_vm.form, "default_item_schedule", $$v);
      },
      expression: "form.default_item_schedule"
    }
  }), _vm.contentScheduleValidate ? _c('p', {
    staticClass: "text-red-500 text-sm mt-1"
  }, [_vm._v("Must be filled.")]) : _vm._e()], 1), _c('div', [_c('label', {
    staticClass: "block text-sm font-medium text-gray-700 mb-2",
    attrs: {
      "for": "name"
    }
  }, [_vm._v(" Release Period ")]), _c('TypeContent', {
    attrs: {
      "options": _vm.defaultReleasePeriodOption,
      "defaultText": 'Select Release Period',
      "isError": _vm.contentPeriodeValidate
    },
    model: {
      value: _vm.form.release_period,
      callback: function ($$v) {
        _vm.$set(_vm.form, "release_period", $$v);
      },
      expression: "form.release_period"
    }
  }), _vm.contentPeriodeValidate ? _c('p', {
    staticClass: "text-red-500 text-sm mt-1"
  }, [_vm._v("Must be filled.")]) : _vm._e()], 1)])])]), _c('div', {
    staticClass: "mb-3 mr-2"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-gray-700 mb-2",
    attrs: {
      "for": "name"
    }
  }, [_vm._v(" Default Languages ")]), _c('multiselect', {
    staticClass: "custom-multiselect",
    class: {
      'error': _vm.submitted && !_vm.form.default_languages
    },
    attrs: {
      "placeholder": "Select Default Languages",
      "open-direction": "bottom",
      "label": "name",
      "track-by": "name",
      "custom-label": _vm.nameWithISO,
      "options": _vm.languagesSearchOptions,
      "searchable": true,
      "close-on-select": true,
      "options-limit": 10,
      "multiple": true,
      "required": ""
    },
    scopedSlots: _vm._u([{
      key: "noResult",
      fn: function () {
        return [_c('span', {
          staticClass: "text-sm text-gray-500 px-2 py-1"
        }, [_vm._v("No publisher found.")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.form.default_languages,
      callback: function ($$v) {
        _vm.$set(_vm.form, "default_languages", $$v);
      },
      expression: "form.default_languages"
    }
  }), _vm.submitted && !_vm.form.default_languages ? _c('p', {
    staticClass: "text-red-500 text-sm mt-1"
  }, [_vm._v("Must be filled.")]) : _vm._e()], 1), _c('div', {
    staticClass: "mb-3 mr-2"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-gray-700 mb-2",
    attrs: {
      "for": "name"
    }
  }, [_vm._v(" Default Countries ")]), _c('multiselect', {
    staticClass: "custom-multiselect",
    class: {
      'error': _vm.submitted && !_vm.form.default_countries
    },
    attrs: {
      "placeholder": "Select Default Countries",
      "open-direction": "bottom",
      "label": "iso",
      "track-by": "iso",
      "custom-label": _vm.nameWithISO,
      "options": _vm.countriesSearchOptions,
      "loading": _vm.isCountriesSearch,
      "searchable": true,
      "close-on-select": true,
      "options-limit": 10,
      "multiple": true
    },
    model: {
      value: _vm.form.default_countries,
      callback: function ($$v) {
        _vm.$set(_vm.form, "default_countries", $$v);
      },
      expression: "form.default_countries"
    }
  }), _vm.submitted && !_vm.form.default_countries ? _c('p', {
    staticClass: "text-red-500 text-sm mt-1"
  }, [_vm._v("Must be filled.")]) : _vm._e()], 1), _c('div', {
    staticClass: "mb-3 mr-0"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-gray-700 mb-2",
    attrs: {
      "for": "name"
    }
  }, [_vm._v(" Description (Optional) ")]), _c('t-textarea', {
    staticClass: "rounded-lg mb-4",
    attrs: {
      "type": "number",
      "placeholder": "Enter description about brand..."
    },
    model: {
      value: _vm.form.description,
      callback: function ($$v) {
        _vm.$set(_vm.form, "description", $$v);
      },
      expression: "form.description"
    }
  })], 1), _c('div', {
    staticClass: "mb-3 mr-0"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-gray-700 mb-2",
    attrs: {
      "for": "name"
    }
  }, [_vm._v(" Status ")]), _c('div', [_c('button', {
    staticClass: "w-12 h-6 button-active-inactive rounded-full relative transition-colors duration-200 focus:outline-none",
    class: {
      'bg-blue-700': _vm.form.is_active,
      'bg-gray-300': !_vm.form.is_active
    },
    attrs: {
      "clas": "",
      "type": "button"
    },
    on: {
      "click": _vm.toggleActive
    }
  }, [_c('span', {
    staticClass: "w-5 h-5 bg-white rounded-full shadow transform transition-transform duration-200",
    class: {
      'translate-x-6': _vm.form.is_active,
      'translate-x-0': !_vm.form.is_active
    }
  })])])]), _c('div', {
    staticClass: "mb-3 mr-0 flex justify-start"
  }, [_c('button', {
    staticClass: "bg-blue-600 text-white px-4 py-2 rounded-lg mr-3",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")]), _c('button', {
    staticClass: "bg-whit text-gray-500 border px-4 py-2 rounded-lg",
    attrs: {
      "type": "reset"
    }
  }, [_c('router-link', {
    staticClass: "text-gray-500 no-underline hover:no-underline hover:text-gray-500",
    attrs: {
      "size": "sm",
      "to": {
        path: '/brands'
      }
    }
  }, [_vm._v(" Cancel ")])], 1)])])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }